// src/components/ArticleQuote.jsx
import React from 'react';

const ArticleQuote = ({ quote }) => {
  if (!quote) {
    return null;
  }
  
  return (
    <blockquote className="article-quote">
      <p className="font-[PP-Museum] font-light italic text-[18px] leading-[35px] align-middle md:text[24px]">{quote}</p>
    </blockquote>
  );
};

export default ArticleQuote;